<template>
  <div class="tip-outter-box" ref="tipOutterBox">
    <div class="tip-box" ref="tipBox" v-if="tipBoxShow">
      {{ tipList[currentShowIndex].title }}
      <span class="close-icon" data-io-click="tracker"  @click="handleNextTip">
        <i class="el-icon-close"></i>
      </span>
      <div class="tri-icon" v-if="tipList[currentShowIndex].type == 1"></div>
    </div>
    <!-- data-io-click="tracker"  @click="handleNextTip" -->
    <div
      class="border-box"
      :class="{ 'no-border': tipList[currentShowIndex].type == 1 }"
      ref="borderBox"
      v-if="borderBoxShow"
    >
      <div
        ref="circleBox"
        v-if="tipList[currentShowIndex].type == 2"
        class="circle"
      ></div>
      <div v-if="tipList[currentShowIndex].type == 2" class="line"></div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
export default {
  props: {
    // 提示列表
    tipList: {
      type: Array,
      default: () => [],
    },
    // 是否显示提示
    showTip: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      // 用户选中的课程包括教材
      currentCourse: "currentCourse",
      currentGuideTipClassName: "currentGuideTipClassName",
      userInfo: "userInfo",
    }),
  },
  data() {
    return {
      // 当前显示的索引
      currentShowIndex: 0,
      tipBoxShow: false,
      borderBoxShow: false,
    };
  },
  watch: {
    currentCourse(val) {
      if (val) {
        // console.log("tipList", this.tipList);
        // this.handleInitCurrentTip();
      }
    },
    showTip(val, oldval) {
      // console.log("showTip前后变化", val, oldval);
      if (val) {
        // console.log("显示提示");
        this.getCurrentShowIndex();
        this.handleInitCurrentTip();
      }
    },
  },
  mounted() {
    // console
  },
  methods: {
    ...mapMutations({
      setCurrentGuideTipClassName: "setCurrentGuideTipClassName",
    }),
    handleNextTip() {
      this.tipBoxShow = false;
      this.borderBoxShow = false;
      if (this.currentShowIndex + 1 < this.tipList.length) {
        this.currentShowIndex++;
        this.saveGuideTipShow();
        this.handleInitCurrentTip();
      } else {
        this.tipBoxShow = false;
        this.borderBoxShow = false;
        this.currentShowIndex = this.tipList.length;
        this.saveGuideTipShow();
        this.$emit("closeTip");
      }
    },
    getCurrentShowIndex() {
      let pageName = this.$route.name;
      let key = `guide-tip-${this.userInfo.userId}`;
      let guideTipInfo = localStorage.getItem(key) || null;
      if (guideTipInfo) {
        guideTipInfo = JSON.parse(guideTipInfo);
        let currentShowIndex = Number(guideTipInfo[pageName]) || 0;
        this.currentShowIndex = currentShowIndex;
        // console.log("currentShowIndex", currentShowIndex, this.tipList.length);
        if (currentShowIndex >= this.tipList.length) {
          this.currentShowIndex = this.tipList.length - 1;
          this.tipBoxShow = false;
          this.borderBoxShow = false;
          this.$emit("closeTip");
        } else {
        }
      }
    },
    saveGuideTipShow() {
      let pageName = this.$route.name;
      let key = `guide-tip-${this.userInfo.userId}`;
      let guideTipInfo = localStorage.getItem(key) || null;
      if (!guideTipInfo) {
        guideTipInfo = {};
      } else {
        guideTipInfo = JSON.parse(guideTipInfo);
      }
      guideTipInfo[pageName] = this.currentShowIndex;
      localStorage.setItem(key, JSON.stringify(guideTipInfo));
    },
    handleInitCurrentTip() {
      this.setCurrentGuideTipClassName(
        this.tipList[this.currentShowIndex].className
      );
      this.$nextTick(() => {
        let index = this.currentShowIndex;
        let list = this.tipList;
        // console.log("tipList", list, index);
        let currentItem = list[index];
        let type = currentItem.type;
        let currentDom = document.querySelector(`.${currentItem.className}`);
        let observer = new IntersectionObserver((e) => {
          console.log("e", e);
          e.forEach((dom) => {
            // isIntersecting为true则dom出现在页面上
            if (dom.isIntersecting) {
              let { x, y, width, height } = currentDom.getBoundingClientRect();
              this.tipBoxShow = true;
              this.borderBoxShow = true;
              this.$nextTick(() => {
                let borderBoxWidth = width + 14;
                let borderBoxHeight = height + 14;
                let tipBoxWidth = this.$refs.tipBox.offsetWidth;
                // this.$refs.borderBox.style.width = borderBoxWidth + "px";
                // this.$refs.borderBox.style.height = borderBoxHeight + "px";
                // this.$refs.borderBox.style.top = y - 7 + "px";
                // this.$refs.borderBox.style.left = x - 7 + "px";
                if (type == 1) {
                  this.$refs.tipBox.style.left = 0 + "px";
                  // this.$refs.tipBox.style.bottom = x + "px";
                  this.$refs.tipBox.style.bottom = -46 + "px";
                  //   this.$refs.tipBox.style.visibility = "visible";
                } else if (type == 2) {
                  this.$refs.tipBox.style.left =
                    (borderBoxWidth - tipBoxWidth) / 2 + "px";
                  this.$refs.tipBox.style.bottom = 18 + "px";
                }
              });
            }
            // dom.isIntersecting ? (dom.target.style.width = "100px") : "";
          });
        }, {});
        observer.observe(currentDom);
        // console.log("currentDom", currentDom, currentItem.className);
        currentDom.appendChild(this.$refs.tipOutterBox);
      });
    },
  },
};
</script>
<style scoped lang="scss">
.tip-box {
  padding: 0 14px 0 13px;
  height: 34px;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 6px;
  position: absolute;
  //   visibility: hidden;
  font-size: 14px;
  color: #fff;
  line-height: 34px;
  z-index: 3000;
  // top: 90px;
  bottom: 18px;
  animation: fadenum 1s;
  width: max-content;
  z-index: 3000;
  .tri-icon {
    position: absolute;
    width: 0px;
    height: 0px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    top: -7px;
    left: 18px;
    // border-top: 3px solid transparent;
    border-bottom: 7px solid rgba(0, 0, 0, 0.8);
  }
  .close-icon {
    cursor: pointer;
    display: inline-block;
    width: 16px;
    height: 16px;
    text-align: center;
    font-weight: bold;
    line-height: 16px;
    &:hover {
      background: rgba(255, 255, 255, 0.2);
      font-size: 8px;
      border-radius: 3px;
    }
  }
}
.border-box {
  position: absolute;
  //   z-index: 2000;
  border-radius: 12px;
  border: 2px dashed #333333;
  animation: fadenum 1s;
  cursor: pointer;
  top: -7px;
  left: -7px;
  right: -7px;
  bottom: -7px;
  //   visibility: hidden;
  .circle {
    position: absolute;
    bottom: -5px;
    width: 8px;
    height: 8px;
    background: #ffffff;
    border: 1px solid #333333;
    border-radius: 50%;
    left: 50%;
    margin-left: -4px;
  }
  .line {
    width: 1px;
    height: 20px;
    border: 1px solid #333333;
    position: absolute;
    bottom: 3px;
    left: 50%;
    margin-left: -0.5px;
    z-index: 200;
  }
  &.no-border {
    border: none;
  }
}
@keyframes fadenum {
  /*设置内容由显示变为隐藏*/
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
